import React from "react";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import "./ConnectWalletButton.css";

const ConnectWalletButton = () => {
  return (
    <div className="connect-wallet-button-container">
      <ConnectButton />
    </div>
  );
};

export default ConnectWalletButton;
